import tableArticles from "./tableArticles"
export default tableArticles;
